import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function Subtitle2({children, ...props}: TypographyProps) {
  return <Typography variant="subtitle2" {...props}>{children}</Typography>
}